import { WhatsAppMsgTypeEnum, WhatsappPriorityEnum } from '@gtpl/shared-models/common-models';

export class WhatsAppBroadCastRequest{
    companyId: number;
    priority: WhatsappPriorityEnum;
	messageType: WhatsAppMsgTypeEnum;
    message: string;
    contacts: string[];
    image ?:string;
}